import { render, staticRenderFns } from "./AppBuilder.vue?vue&type=template&id=6768f5a0&scoped=true&"
import script from "./AppBuilder.vue?vue&type=script&lang=js&"
export * from "./AppBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AppBuilder.vue?vue&type=style&index=0&id=6768f5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768f5a0",
  null
  
)

export default component.exports